import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { colors } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'
import Page from '../../../../internal/Page'
import PageActionBar from '../../../../internal/PageActionBar'
import { getDeepOr } from '../../../../util/helpers'
import styles from '../../shared/transactions.style'
import TransactionCartStore from '../../TransactionCart/TransactionCartStore'
import TransactionHistory from '../../TransactionHistory'
import { TransactionStatus } from '../../../../util/transactionConstants'
import PageWrapper from '../../../../internal/PageWrapper'

const SimpleTransactionDetailsUI = props => {
  return (
    <>
      <Page
        title={getText('transactions.transaction.specificationSimple.title')}
      >
        <PageActionBar
          items={
            <h4 style={styles.name}>
              <span style={styles.grayNameLabel}>
                {getText(
                  'transactions.transaction.specificationSimple.accountLabel',
                )}{' '}
              </span>
              {getDeepOr(
                getDeepOr('', props.transaction, 'accountNumber'),
                props.transactionDetails,
                'account.accountNumber',
              )
                .match(/.{0,4}/g)
                .join(' ')}
            </h4>
          }
        />
        <TransactionCartStore
          transactionDetails={props.transactionDetails}
          orderLimit={props.orderLimit}
          onBack={() => props.onBack()}
        />
        <Conditional when={!!props.transactionDetails}>
          <TransactionHistory
            details={props.transactionDetails}
            transaction={props.transaction}
          />
        </Conditional>
      </Page>

      <Conditional
        when={
          !!props.transactionDetails &&
          props.transactionDetails.status === TransactionStatus.FROZEN
        }
      >
        <PageWrapper type="danger">
          <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
            <span style={{ ...styles.name, color: colors.errorMain }}>
              {getText('transactions.frozen')}
            </span>
          </h4>

          <div style={{ padding: '1rem' }}>
            {getText('transactions.infoFrozen')}
          </div>
        </PageWrapper>
      </Conditional>
    </>
  )
}

SimpleTransactionDetailsUI.propTypes = {
  transactionDetails: PropTypes.object,
  transaction: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  orderLimit: PropTypes.number,
}

SimpleTransactionDetailsUI.defaultProps = {
  transactionDetails: null,
  transaction: null,
  orderLimit: 0,
}

export default SimpleTransactionDetailsUI
